import '@/assets/styles/global.scss'
import type {AppContext, AppProps} from 'next/app'
import Layout from "@/components/Layout/Layout";
import {CookiesProvider} from "react-cookie";
import Cookies from "universal-cookie";
import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
import {useRouter} from "next/router";
import ErrorBoundary from "@/components/ErrorBoundary/ErrorBoundary";
import ThemeProvider from '@/components/ThemeProvider/ThemeProvider';
import NextNProgress from 'nextjs-progressbar'
import AdProvider from "@/components/AdProvider/AdProvider";
import GoogleAnalytics from "@/components/GoogleAnalytics/GoogleAnalytics";
import ToastProvider from "@/components/ToastProvider/ToastProvider";

config.autoAddCss = false
export default function App({ Component, pageProps, cookies }: AppProps & { cookies: any, isEDHREC: boolean }) {
  const isBrowser = typeof window !== 'undefined'
  const router = useRouter()

  return (
    <ErrorBoundary>
      <CookiesProvider cookies={isBrowser ? undefined : new Cookies(cookies)}>
        <ThemeProvider>
          <ToastProvider>
            <GoogleAnalytics/>
            <div
              id="mediavine-settings"
              data-blocklist-adhesion-mobile="1"
              data-blocklist-adhesion-tablet="1" 
              data-blocklist-universal-player-mobile={router.asPath.includes('/crossword') ? '1' : '0'}
              data-blocklist-universal-player-desktop={router.asPath.includes('/crossword') ? '1' : '0'}
              data-expires-at="2038-01-01"></div>
            <AdProvider>
              <Layout>
                <NextNProgress options={{showSpinner: false}} showOnShallow={false}/>
                <Component {...pageProps} />
              </Layout>
            </AdProvider>
          </ToastProvider>
        </ThemeProvider>
      </CookiesProvider>
    </ErrorBoundary>
  )

}

App.getInitialProps = async (context: AppContext): Promise<any> => {
  return {
    cookies: context.ctx.req?.headers?.cookie,
    isEDHREC: true
  }
}
